/**
 * Helper para redirigir usuarios según su rol después del login
 */

export type UserRole = "ALUMNO" | "PROFESOR" | "ADMIN" | "ADMINCOLEGIO";

/**
 * Obtiene la ruta de redirección según el rol del usuario
 */
export const getRoleDefaultRoute = (rol: UserRole): string => {
  const roleRoutes: Record<UserRole, string> = {
    ADMIN: "/admin",
    ADMINCOLEGIO: "/admin-colegio", // Para futuro
    PROFESOR: "/profesor",
    ALUMNO: "/alumno", // Para futuro si es necesario
  };

  return roleRoutes[rol] || "/";
};

/**
 * Valida si un usuario tiene acceso a una ruta específica
 */
export const canAccessRoute = (
  userRole: UserRole,
  requiredRoles: UserRole[]
): boolean => {
  return requiredRoles.includes(userRole);
};

/**
 * Obtiene el nombre legible del rol
 */
export const getRoleName = (rol: UserRole): string => {
  const roleNames: Record<UserRole, string> = {
    ADMIN: "Administrador",
    ADMINCOLEGIO: "Administrador de Colegio",
    PROFESOR: "Profesor",
    ALUMNO: "Alumno",
  };

  return roleNames[rol] || "Usuario";
};
